module.exports = __webpack_public_path__ + "graphics/03.ckh.14ad6144187ca802765e6506953e5896.png";